
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-provision",
      function () {
        return require("private-next-pages/service-provision.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-provision"])
      });
    }
  